export enum AlarmLevel {
    Information,
    Warning,
    Critical
}